// extracted by mini-css-extract-plugin
module.exports = {"list":"institutions-searchable_list__tYWwP","item":"institutions-searchable_item__1RPAC","select":"institutions-searchable_select__Dexje"};